export default "__VITE_ASSET__CnzaEw7o__"